function identity(data) {
  return data;
}
function isTimeout(ms) {
  return typeof ms === 'number' && ms > 0 && Number.isFinite(ms);
}
function raceCancelAndTimeout(cancel, timeoutMs) {
  let timer = null;
  const fired = new Promise(function (resolve) {
    Promise.resolve(cancel).then(resolve, function () {});
    timer = setTimeout(resolve, timeoutMs);
  });
  return {
    promise: fired,
    settle: function () {
      if (timer !== null) clearTimeout(timer);
      timer = null;
    }
  };
}
export function angularTimeoutFor(cancel, timeoutMs) {
  if (cancel && isTimeout(timeoutMs)) {
    const race = raceCancelAndTimeout(cancel, timeoutMs);
    return {
      timeout: race.promise,
      settle: race.settle
    };
  }
  const noop = function () {};
  if (cancel) return {
    timeout: cancel,
    settle: noop
  };
  if (isTimeout(timeoutMs)) return {
    timeout: timeoutMs,
    settle: noop
  };
  return {
    timeout: undefined,
    settle: noop
  };
}
import { createFetchStreamer } from './fetchStreamer.js';
function responseHeaderGetter(response) {
  if (!response || typeof response.headers !== 'function') return null;
  return function (name) {
    if (!name) return null;
    try {
      const value = response.headers(name);
      return value === undefined || value === null ? null : value;
    } catch (e) {
      return null;
    }
  };
}
export function createAngularHttpTransport($http, opts) {
  const streamOpts = opts && opts.stream;
  const ngQ = opts && opts.ngQ;
  function reject(reason) {
    if (ngQ) return ngQ.reject(reason);
    throw reason;
  }
  const transport = {
    reject: reject,
    request: function (req) {
      const hasBody = req.body !== undefined && req.body !== null;
      const config = {
        method: req.method || 'GET',
        url: req.path
      };
      if (hasBody) config.data = req.body;
      const aborts = angularTimeoutFor(req.cancel, req.timeoutMs);
      if (aborts.timeout !== undefined) config.timeout = aborts.timeout;
      if (req.responseType === 'text') config.transformResponse = [identity];
      if (req.headers) config.headers = Object.assign({}, req.headers);
      return $http(config).then(function (response) {
        aborts.settle();
        const out = {
          status: response.status,
          data: response.data
        };
        const getHeader = responseHeaderGetter(response);
        if (getHeader) out.headers = getHeader;
        return out;
      }, function (rejection) {
        aborts.settle();
        const status = rejection && typeof rejection.status === 'number' && rejection.status > 0 ? rejection.status : 0;
        const out = {
          status: status,
          data: rejection ? rejection.data : null
        };
        if (rejection && typeof rejection.statusText === 'string') out.statusText = rejection.statusText;
        const getHeader = status > 0 ? responseHeaderGetter(rejection) : null;
        if (getHeader) out.headers = getHeader;
        return reject(out);
      });
    }
  };
  if (streamOpts) transport.streamLines = createFetchStreamer(streamOpts).streamLines;
  return transport;
}